/* global System */

export default {
  EmbedYouTube: () =>
    System.import(/* webpackChunkName: "EmbedYouTube" */ './index'),
}
